import { endOfDay, startOfDay } from 'date-fns';

import { PayloadAction } from '../../../store.model';
import { ActionType } from '../transcript-import-dialog.action';
import { TranscriptImportDialogState } from '../transcript-import-dialog.state';

import { SelectDateRange } from './select-date-range.action';

export function selectDateRangeReducer(
    state: TranscriptImportDialogState,
    action: PayloadAction<ActionType, SelectDateRange>,
): TranscriptImportDialogState {
    return {
        ...state,
        dateRange: {
            from: startOfDay(action.payload.from),
            to: endOfDay(action.payload.to),
        },
    };
}
